import { render, staticRenderFns } from "./BannerSmallForm.vue?vue&type=template&id=085ef8c7&scoped=true&"
import script from "./BannerSmallForm.vue?vue&type=script&lang=js&"
export * from "./BannerSmallForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerSmallForm.vue?vue&type=style&index=0&id=085ef8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ef8c7",
  null
  
)

export default component.exports